<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button mat-raised-button color="primary" (click)="confirmed()" cdkFocusInitial>Sí</button>
    <button mat-button color="primary" (click)="closeDialog()">No</button>
</div>
